import Checkbox from 'components/Globals/Base/Checkbox';
import Select, { type StylesConfig } from 'react-select';
import Input from 'components/Globals/Base/Input';
import showLogin from 'services/Piano/showLogin';
import showRegister from 'services/Piano/showRegister';
import { font } from 'styles/globals';
import type { Dispatch, SetStateAction } from 'react';
import Cookies from 'js-cookie';
import Link from 'components/Globals/Base/Link';
import { getColor } from 'styles/theme';
import { countryList } from './personalInfoSelectOptions';
import DropdownIndicator from './DropdownIndicator';
import * as S from './NewsletterGuestPopupStyles';

const myAccountSelectStyles: StylesConfig = {
  control: (provided, state) => ({
    ...provided,
    '&:hover': {
      boxShadow: `0 0 0 1px ${getColor('neutralBlack')}`,
    },
    border: `1px solid ${getColor('neutralBlack')}`,
    borderRadius: '0px',
    boxShadow: state.isFocused ? `0 0 0 1px ${getColor('neutralBlack')}` : 'none',
    color: `${getColor('neutralBlack')}`,
    font: `${font.graphikCond}`,
    fontFamily: `${font.graphikCond}`,
    fontWeight: '400',
    height: '40px',
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    color: `${getColor('neutralDarkGray')}`,
  }),
  indicatorSeparator: () => ({
    display: 'none',
  }),
  indicatorsContainer: (provided) => ({
    ...provided,
    height: '42px',
  }),
  input: (provided) => ({
    ...provided,
    margin: '-4px',
  }),
  valueContainer: (provided) => ({
    ...provided,
    height: '40px',
    padding: '0 16px 4px 16px',
  }),
};

const guestModalChildren = (
  setIsModalOpen: Dispatch<SetStateAction<boolean>>,
  inputEmail: string,
  setInputEmail: Dispatch<SetStateAction<string>>,
  emailError: boolean,
  inputCountry: { label: string; value: string },
  setInputCountry: Dispatch<SetStateAction<{ label: string; value: string }>>,
  countryError: boolean,
  checked: boolean,
  setChecked: Dispatch<SetStateAction<boolean>>,
  emailExists: boolean,
  formName?: string,
) => (
  <S.GuestPopupWrapper>
    <S.AccountWrapper>
      <S.LinkButton
        className='login-button'
        onClick={() => {
          showLogin();
          setIsModalOpen(false);
          if (formName) {
            Cookies.set('newsletter_formName', formName, {
              expires: new Date(new Date().getTime() + 60 * 60 * 1000),
            });
          }
        }}
      >
        Log In
      </S.LinkButton>
      or
      <S.LinkButton
        className='create-button'
        onClick={() => {
          showRegister();
          setIsModalOpen(false);
          if (formName) {
            Cookies.set('newsletter_formName', formName, {
              expires: new Date(new Date().getTime() + 60 * 60 * 1000),
            });
          }
        }}
      >
        Create an account
      </S.LinkButton>
    </S.AccountWrapper>
    <S.SeparatorWrapper>
      <hr className='line' />
      OR
      <hr className='line' />
    </S.SeparatorWrapper>
    <S.Subtitle>Subscribe to Fortune newsletters as a guest.</S.Subtitle>
    <S.FormWrapper>
      <Input
        placeholder='Email address'
        value={inputEmail}
        onChange={setInputEmail}
        className={`email-input ${emailError || emailExists ? 'error' : ''}`}
        size={{ default: 'small' }}
      />
      <Select
        placeholder='Country'
        components={{ DropdownIndicator }}
        options={countryList}
        value={countryList.find((opt) => opt.value === inputCountry.value)}
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        onChange={(option: any) => setInputCountry(option)}
        styles={myAccountSelectStyles}
        className={`country-input ${countryError ? 'error' : ''}`}
      />
    </S.FormWrapper>
    <S.EmailError>{emailExists ? 'This email is associated to an account. Please try logging in.' : ''}</S.EmailError>
    <S.PolicyWrapper>
      By creating an account, I have read and agree to{' '}
      <Link
        href='/terms-of-use/'
        target='_blank'
        className='internal-page-link'
      >
        Fortune’s Terms of Use
      </Link>{' '}
      and{' '}
      <Link
        href='/privacy-policy/'
        target='_blank'
        className='internal-page-link'
      >
        Privacy Policy
      </Link>
      <Checkbox
        name='opt-in'
        value={checked}
        onChange={setChecked}
        required
        className='checkbox'
      >
        Fortune may send me Fortune newsletters and offer me other Fortune products and services by email. I can opt out
        at any time.
      </Checkbox>
    </S.PolicyWrapper>
  </S.GuestPopupWrapper>
);

export default guestModalChildren;
